export default [{
  path: '/telegram-manager',
  name: 'telegramManager',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/telegramManager/index')
}]
